module.exports = __webpack_public_path__ + "static/img/40009 (2).f49fc17.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40009 (2).webp
// module id = xqU9
// module chunks = 14